import { render } from "./addschedule.vue?vue&type=template&id=c398948c&scoped=true"
import script from "./addschedule.vue?vue&type=script&lang=js"
export * from "./addschedule.vue?vue&type=script&lang=js"

import "./addschedule.vue?vue&type=style&index=0&id=c398948c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c398948c"]])

export default __exports__